import { combineReducers } from 'redux'
import { routerReducer } from 'react-router-redux'
import { config } from './config'
import { colors, backgroundColors } from './colors'
import { navigation } from './navigation'
import { reducer as notificationsReducer } from 'reapop'
import referenceData from './referenceData'
import initialState from '../mi-app/language/reducer'
import { permissions } from './permission'
import assistant from './assistant'

const rootReducer = combineReducers({
  config,
  colors,
  backgroundColors,
  navigation,
  router: routerReducer,
  notifications: notificationsReducer(),
  referenceData,
  pageContent: initialState,
  permissions,
  assistant
})

export default rootReducer



// WEBPACK FOOTER //
// ./src/reducers/index.js